<fieldset>
 <legend>
  MarcheNegocie
 </legend>
 <fieldset>
 <legend>
  candidatsDejaSelectionnes
 </legend>
 <app-type-oui-non  [uid]="getUid()" [parentForm]="parentForm" [candidatsDejaSelectionnes]="marcheNegocie.candidatsDejaSelectionnes"></app-type-oui-non>
</fieldset>
</fieldset>
